import React from 'react';
import "./RadioButtonField.css";

const RadioButtonField = ({ name, question, value, setCallback, display = true }) => {
    const radioOptions = [
        { value: "1", label: "Yes" },
        { value: "0", label: "No" }
    ];

    if (!display) {
        return null;
    }

    return (
        <div className={`row my-3 justify-content-start`}>
            <div className="col-12 col-sm-6">
                <p className='text-primary fw-bold field'>
                    {question}
                </p>
            </div>
            <div className="col-12 col-sm-6">
                {radioOptions.map((option) => (
                    <RadioOption
                        key={option.value}
                        name={name}
                        value={option.value}
                        label={option.label}
                        checked={value == option.value}
                        setCallback={setCallback}
                    />
                ))}
            </div>
        </div>
    );
};

const RadioOption = ({ name, value, label, checked, setCallback }) => (
    <div className="radio-inline form-check-inline me-3" style={{ paddingLeft: 0 }}>
        <label style={{ fontSize: '13px' }}>
            <input
                type="radio"
                className="form-check-input me-2"
                name={name}
                value={value}
                checked={checked}
                onChange={(e) => setCallback(name, e.target.value)}
            />
            {label}
        </label>
    </div>
);

export { RadioButtonField };